import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVocabulary } from '@plone/volto/actions';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import { Icon, SidebarPortal } from '@plone/volto/components';
import GraduationHatSVG from '@package/svgs/icons/graduation-hat.svg';
import View from './View';
import LecturesBlockSchema from './schema';

const Edit = (props) => {
  const dispatch = useDispatch();

  const semestersVocab = useSelector(
    (state) => state.vocabularies['lsf.semesters'],
  );
  const semesters = (semestersVocab?.items || []).map((item) => [
    item.value,
    item.label,
  ]);

  useEffect(() => {
    if (semesters.length === 0)
      dispatch(getVocabulary({ vocabNameOrURL: 'lsf.semesters' }));
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [dispatch]);

  const schema = LecturesBlockSchema(props.intl, semesters);
  return (
    <>
      <SidebarPortal selected={props.selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          icon={<Icon name={GraduationHatSVG} />}
          onChangeField={(id, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          formData={props.data}
        />
      </SidebarPortal>
      <View
        data={props.data}
        isEditMode={true}
        key={props.data.from_semester_id}
      />
    </>
  );
};

export default Edit;
